import { defineTitleId } from './defineTitleId';

import { normalizeTitle } from './normalizeTitle';

import { insertTitleFromBlok } from './insertTitleFromBlok';

import type { ISbComponentType } from 'storyblok-js-client';
import type { BlokAnchorInfo, Locales } from '@monoimin/sb-types';

export function createBlockTitleAnchorInfo<
  T extends { title?: string | null },
  Y extends string
>(
  blok: ISbComponentType<Y> & T,
  locale: Locales,
  hrefPrefix = ''
): BlokAnchorInfo | null {
  const { title: blockTitle, component } = blok;

  const title = insertTitleFromBlok(component, locale, blockTitle);

  if (title) {
    const normaliziedTitle = normalizeTitle(title);

    const id = defineTitleId(title, locale);

    return {
      href: `${hrefPrefix}#${id}`,
      title: normaliziedTitle,
      titleId: id,
    };
  }

  return null;
}

export default createBlockTitleAnchorInfo;
